<template>
  <Protect
    :permissions="[
      SYS_PERMISSIONS.SYS_MEMBERSHIPS_READ,
      SYS_PERMISSIONS.SYS_MEMBERSHIPS_MANAGE,
    ]"
  >
    <h1
      class="text-[24px] md:text-[30px] font-normal md:font-thin text-white mb-10 px-12 md:px-0"
    >
      People
    </h1>
    <MembersView />
    <template #fallback>
      <NoAccess />
    </template>
  </Protect>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import MembersView from '@features/workspaces/MembersView.vue';
import { SYS_PERMISSIONS } from '@/constants.js';

import NoAccess from '@components/common/NoAccess.vue';
</script>
